import React,{useEffect, useState, useContext} from 'react'
import { useNavigate } from 'react-router-dom'
import './Project.css'
import {portfolioRef} from '../../Firebase/collections'
import { getDocs } from 'firebase/firestore'
import {portfolioPathContext} from '../../appContext'
import Loading from '../Loading/Loading'

function Project() {
    const [portfolioList, setPortfolioList] = useState([])
    const Navigate = useNavigate()
    const { setFolioPath } = useContext(portfolioPathContext)
    const [loadingScreen, setLoadingScreen] = useState(true)

    useEffect(() => {
      getDocs(portfolioRef).then(snap => {
        setLoadingScreen(false)
        setPortfolioList(snap.docs.map(doc => doc.data()))
      })
    }, [])

    const handlePath = (path,callback) => {
        callback(path)
    }
    
    return (
        <div className='project'>
            {loadingScreen ?<Loading/>:null}
            <div className="project-container">
                {
                    portfolioList.map(({name,image,link,id},index) => {
                        return (
                        <div key={index} className="project-box">
                            <img src={image} alt="project_image" />
                            <div className='project-info'>
                                <h3>{name}</h3>
                                <button title='info' onClick={() => {
                                    handlePath(`/portfolio:${id}`,(res) => {
                                        setFolioPath(res)
                                        Navigate(res)
                                    })
                                    }}><i className="fa fa-info" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Project
